import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { ResultadosService } from '../resultados.service';
import { AuthService } from 'app/auth/auth.service';

import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-covid',
  templateUrl: './covid.component.html',
  styleUrls: ['./covid.component.scss'],
  animations : fuseAnimations
})
export class CovidComponent implements OnInit {
  cargando = true;
  idInstituto: string;

  urlTableauCovid = DATOS_API.urlTableauCovid;
  // tokenTableau: string;

  //variablesTableau de Covid
  // ctoken: string;
  // user: string;
  // ulvl: number;
  // broker: number;
  langCode: number;
  infoUsuario:any;
  cvk:any;
  brk: number;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private activatedRoute:ActivatedRoute,
    private servTableau: ResultadosService,
    private translateSrv: TranslateService,
    private authService: AuthService
  ) {
    lang_resultados.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.idInstituto = this.authService.getInstituto();
    switch (this.idInstituto) {
      case '1': case 'MX':
        this.urlTableauCovid = this.urlTableauCovid.replace("--VERSION--","3.2");
      break;
      default:
        this.urlTableauCovid = this.urlTableauCovid.replace("--VERSION--","3.1");
    }
    this.colocaIdioma();
    if(localStorage.getItem('productoID') == 'admin'){
      // this.tokenTableau = '999e72f4-ba5c-4906-aea2-8532488883d4';
      // this.ctoken = 'xxx';
      // this.user = 'admin@itbm.mx';
      // this.ulvl = 1;
      // this.broker = 1;
      this.cvk = 'xxx';
      this.cargando = false;
      setTimeout(() => {
        $('#RecDatos').submit();
      },1000);
    }
    else{
      this.infoUsuario=this.authService.getInfoUsuario();
      // console.log(this.infoUsuario.user);
      let datos = {user:this.infoUsuario.user};
      // console.log(datos);
      this.servTableau.getParamsTableauCovid(datos).subscribe( (respuesta:backInter.getParamsTableauCovid) => {
        console.log(respuesta);
          this.cvk = respuesta.idCompany;
          this.brk = respuesta.idBroker;
          this.cargando = false;
          setTimeout(() => {
            // console.log("se dispara form alv");
            $('#RecDatos').submit();
          },1000);

      });
    }

  }

  colocaIdioma(){
    switch(this.translateSrv.currentLang){
      case 'es': this.langCode = 60; break;
      default: this.langCode = 18;
    }
  }

}
